import React from 'react';
import PropTypes from 'prop-types';

import {FormattedHTMLMessage} from 'react-intl';
import cx from 'classnames';

export default function WizardSteps({steps, active}) {
  active -= 1;

  return (
    <div className="checkout__steps">
      {steps.map((title, idx) => (
        <div
          key={idx}
          className={cx({
            'checkout__step': true,
            'checkout__step--active': idx === active,
            'checkout__step--completed': idx < active
          })}
        >
          <div className="checkout__step-body">
            <div className="checkout__step-number">{idx >= active ? idx + 1 : ' '}</div>
            <p className="checkout__step-text">
              <FormattedHTMLMessage id={title}/>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/checkout/WizardSteps.js